import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Filter out chrome-extension errors
    if (
      error?.stack?.includes('chrome-extension://') ||
      info?.componentStack?.includes('chrome-extension://')
    ) {
      console.warn('Extension error caught:', error);
    } else {
      // Handle app errors (e.g., show fallback UI or log to monitoring)
      console.error('App error:', error);
    }
  }

  render() {
    return this.props.children;
  }
}
